import image1 from "../../../assets/images/birthday/IMG_1979.JPG"
import image2 from "../../../assets/images/birthday/IMG_1980.JPG"
import image4 from "../../../assets/images/birthday/IMG_1982.JPG"
import image5 from "../../../assets/images/birthday/IMG_1983.JPG"
import image6 from "../../../assets/images/birthday/IMG_1984.JPG"
import image7 from "../../../assets/images/birthday/IMG_1985.JPG"
import image8 from "../../../assets/images/birthday/IMG_1986.JPG"
import image9 from "../../../assets/images/birthday/IMG_1987.JPG"
import image10 from "../../../assets/images/birthday/IMG_1988.JPG"
import image11 from "../../../assets/images/birthday/IMG_1989.JPG"
import image12 from "../../../assets/images/birthday/IMG_1990.JPG"
import image13 from "../../../assets/images/birthday/IMG_1991.JPG"
import image14 from "../../../assets/images/birthday/IMG_1992.JPG"
import image15 from "../../../assets/images/birthday/IMG_1993.JPG"
import image16 from "../../../assets/images/birthday/IMG_1994.JPG"
import image17 from "../../../assets/images/birthday/IMG_1995.JPG"
import image18 from "../../../assets/images/birthday/IMG_1996.JPG"
import image19 from "../../../assets/images/birthday/IMG_1997.JPG"
import image20 from "../../../assets/images/birthday/IMG_1998.JPG"





export const birthdayImages = [
    image1,
    image2,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,

]

